import api from './api';

const searchService = {
  /**
   * Quick search for header dropdown (returns up to 5 mixed results).
   */
  quickSearch: async (query) => {
    const response = await api.get('/v1/search/', { params: { q: query } });
    return response;
  },

  /**
   * Paginated search filtered by type (member, team, channel, message).
   */
  search: async (query, type, page = 1, pageSize = 20) => {
    const response = await api.get('/v1/search/', {
      params: { q: query, type, page, page_size: pageSize },
    });
    return response;
  },
};

export default searchService;
